import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import PostTable from '@cms/components/tables/post-table/post-table.vue';

@Component({
  name: 'bpc-post-online-training',
  components: {
    'bpc-post-table': PostTable,
  },
})
export default class PostOnlineTraining extends Vue {
  public filterConfigName = 'training-filters';

  /* Lifecycle hooks */
  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}
}
